
const ReducerStateContant = {
    fulfilled: 'fulfilled',
    pending: 'pending',
    rejected: 'rejected'
}
const defaultButtonColor = '#337ab7'
export { ReducerStateContant,defaultButtonColor };